import axios from "axios";
import { getHeaders, makeRequest } from "$utils/utils";

import constants from "$utils/constants";

// eslint-disable-next-line consistent-return
export const getCategory = async (
  token: string,
  company = "",
  withReferencing = true
) => {
  try {
    if (company) {
      const params =
        company?.trim().length > 0 ? { company, withReferencing } : undefined;
      const response = await axios.get(constants.API.ENDPOINTS.CATEGORY.GET, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response;
    }
  } catch (err) {
    const error = (err as any)?.response?.data?.message;
    return { error };
  }
};

export default { getCategory };

export const addCategory = async (token: string, data: any) => {
  try {
    const res = await makeRequest(
      constants.API.ENDPOINTS.CATEGORY.ADD,
      "POST",
      data,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error("Error when adding category");
    }
    return res;
  } catch (err) {
    const error = (err as any)?.response?.data?.message;
    return { error };
  }
};

export const editCategory = async (token: string, data: any, id: string) => {
  try {
    const res = await makeRequest(
      `${constants.API.ENDPOINTS.CATEGORY.EDIT}/${id || ""}`,
      "PUT",
      data,
      getHeaders(token)
    );

    if (!res || !res.data || !res.data.status) {
      throw new Error("Error when editing category");
    }
    return res;
  } catch (err) {
    const error = (err as any)?.response?.data?.message;
    return { error };
  }
};

export const deleteCategory = async (token: string, id: string) => {
  try {
    const res = await makeRequest(
      `${constants.API.ENDPOINTS.CATEGORY.DELETE}/${id}`,
      "DELETE",
      undefined,
      getHeaders(token)
    );
    return res.data;
  } catch (err: any) {
    throw new Error(
      err.response?.data?.message ||
        "Erreur lors de la suppression d'une catégorie"
    );
  }
};
